import { startLoginWithMicrosoft } from "actions/authFunctions"
import LoginButton from "components/utils/loginButtons/LoginButton"
import microsoftIcon from "images/login/microsoft.svg"

const MicrosoftLoginButton = () => {
  return <LoginButton icon={microsoftIcon} text="Mit Microsoft anmelden" onClick={startLoginWithMicrosoft} />
}

export default MicrosoftLoginButton
